let authMethod = null;
let authenticated = null;
export default { 
	setAuthMethod(token) {
  		authMethod = token;
	},
	getAuthThing() {
  		return authMethod;
	},

	setAuthenticated(a) {
		authenticated = a;
	},
	getAuthenticated(a) {
		return authenticated;
	}

}

